import React, { useEffect } from "react";

import { Helmet } from "react-helmet-async";

import { Link } from "react-router-dom";

import { FiArrowRight } from "react-icons/fi";

import { useTranslation } from "react-i18next";

import "./Cuisine.css";

import plovImg from "../photos/food4.webp";
import mantiImg from "../photos/manti.jpg";
import samsaImg from "../photos/somsa.jpg";
import lagmanImg from "../photos/lagmon.jpg";

const dishes = [
    {
        id: "plov",
        image: plovImg,
    },
    {
        id: "manti",
        image: mantiImg,
    },
    {
        id: "samsa",
        image: samsaImg,
    },
    {
        id: "lagman",
        image: lagmanImg,
    },
];

export default function Cuisine() {
    const { t } = useTranslation();

    useEffect(() => {
        const elements =
            document.querySelectorAll(".cuisine-reveal");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
            }
        );

        elements.forEach((element) =>
            observer.observe(element)
        );

        return () => observer.disconnect();
    }, []);

    return (
        <main className="cuisine-page">
            <Helmet>
                <title>
                    {t("cuisine.seo_title")}
                </title>

                <meta
                    name="description"
                    content={t("cuisine.seo_description")}
                />
            </Helmet>

            {/* =========================
                HERO
            ========================= */}

            <section className="cuisine-hero cuisine-reveal">
                <div className="cuisine-hero-glow" />

                <span className="cuisine-eyebrow">
                    {t("cuisine.eyebrow")}
                </span>

                <h1 className="cuisine-title">
                    {t("cuisine.hero_title")}
                    <span>
                        {t("cuisine.hero_title_highlight")}
                    </span>
                </h1>

                <p className="cuisine-intro">
                    {t("cuisine.hero_description")}
                </p>

                <div className="cuisine-divider">
                    <span />
                </div>
            </section>

            {/* =========================
                DISHES
            ========================= */}

            <section className="cuisine-dishes">
                <div className="cuisine-section-heading cuisine-reveal">
                    <div>
                        <span className="section-label">
                            {t("cuisine.section_label")}
                        </span>

                        <h2>
                            {t("cuisine.section_title")}
                        </h2>
                    </div>

                    <p>
                        {t("cuisine.section_description")}
                    </p>
                </div>

                <div className="cuisine-grid">
                    {dishes.map((dish, index) => (
                        <Link
                            key={dish.id}
                            to={`/cuisine/${dish.id}`}
                            className={`cuisine-card cuisine-reveal card-${index + 1}`}
                            aria-label={`${t(
                                `cuisine.dishes.${dish.id}.title`
                            )} ${t("cuisine.about_details")}`}
                        >
                            <div className="cuisine-card-image">
                                <img
                                    src={dish.image}
                                    alt={t(
                                        `cuisine.dishes.${dish.id}.title`
                                    )}
                                    loading={
                                        index === 0
                                            ? "eager"
                                            : "lazy"
                                    }
                                />

                                <div className="cuisine-card-dark" />

                                <div className="cuisine-card-shine" />

                                <span className="cuisine-number">
                                    {String(index + 1).padStart(
                                        2,
                                        "0"
                                    )}
                                </span>

                                <div className="cuisine-card-content">
                                    <span className="cuisine-card-small">
                                        {t(
                                            "cuisine.national_dish"
                                        )}
                                    </span>

                                    <h3>
                                        {t(
                                            `cuisine.dishes.${dish.id}.title`
                                        )}
                                    </h3>

                                    <p>
                                        {t(
                                            `cuisine.dishes.${dish.id}.description`
                                        )}
                                    </p>

                                    <span className="cuisine-card-link">
                                        {t(
                                            "cuisine.view_details"
                                        )}

                                        <FiArrowRight />
                                    </span>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>

            {/* =========================
                BOTTOM
            ========================= */}

            <section className="cuisine-bottom cuisine-reveal">
                <span>
                    {t("cuisine.bottom_brand")}
                </span>

                <h2>
                    {t("cuisine.bottom_title")}

                    <br />

                    {t(
                        "cuisine.bottom_title_highlight"
                    )}
                </h2>
            </section>
        </main>
    );
}